import { MediaFormatEnum } from '../../../../../general-settings/enums/mediaFormat.enum';
import { THUMB_GAP } from '../../consts/gallery.consts';
import {
  GetSquareStackPageParams,
  GetThumbLayoutParams,
  ThumbLayout,
} from '../../interfaces/productGallery.interfaces';
import { getMediaAspectRatio } from '../../utils/mediaAspectRatio.utils';

export const SQUARE_ASPECT_RATIO = getMediaAspectRatio(MediaFormatEnum.SQUARE);

export const SQUARE_STACK_MEDIAS = 3;

const THUMB_ROWS = 1;
const MAX_THUMB_COLUMNS = 3;
const COLUMN_FIT_TOLERANCE = 1;

export const getSquareGalleryColumnWidth = (galleryHeight: number) => {
  const availableHeight = galleryHeight - THUMB_GAP * THUMB_ROWS;

  if (availableHeight <= 0) {
    return 0;
  }

  const thumbRowsShare = THUMB_ROWS / MAX_THUMB_COLUMNS;
  const thumbGaps = (THUMB_GAP * (MAX_THUMB_COLUMNS - 1) * THUMB_ROWS) / MAX_THUMB_COLUMNS;

  return (availableHeight + thumbGaps) / (1 + thumbRowsShare);
};

const getThumbSizeToFillColumn = ({ galleryWidth, galleryHeight }: GetThumbLayoutParams) =>
  (galleryHeight - galleryWidth - THUMB_GAP * THUMB_ROWS) / THUMB_ROWS;

const getThumbSizeByColumns = (galleryWidth: number, columns: number) =>
  (galleryWidth - THUMB_GAP * (columns - 1)) / columns;

const getFittedThumbColumns = (params: GetThumbLayoutParams) => {
  const thumbSize = getThumbSizeToFillColumn(params);

  if (thumbSize <= 0) {
    return MAX_THUMB_COLUMNS;
  }

  const columns = Math.floor(
    (params.galleryWidth + THUMB_GAP + COLUMN_FIT_TOLERANCE) / (thumbSize + THUMB_GAP),
  );

  return Math.min(MAX_THUMB_COLUMNS, Math.max(1, columns));
};

export const getSquareThumbLayout = (params: GetThumbLayoutParams): ThumbLayout => {
  const columns = getFittedThumbColumns(params);

  const thumbSize = Math.max(
    0,
    Math.min(getThumbSizeToFillColumn(params), getThumbSizeByColumns(params.galleryWidth, columns)),
  );

  return {
    thumbWidth: thumbSize,
    thumbHeight: thumbSize,
    thumbRows: THUMB_ROWS,
    thumbColumns: columns,
    maxThumbs: columns * THUMB_ROWS,
  };
};

export const getSquareStackColumnWidth = (galleryHeight: number) =>
  Math.max(0, (galleryHeight - THUMB_GAP * (SQUARE_STACK_MEDIAS - 1)) / SQUARE_STACK_MEDIAS);

export const getSquareStackPage = ({ medias, page }: GetSquareStackPageParams) =>
  medias.slice(page * SQUARE_STACK_MEDIAS, page * SQUARE_STACK_MEDIAS + SQUARE_STACK_MEDIAS);
